import { DropdownItems } from '../components/weather/settings/settings-options';
import { UDViewTagSelectionEnum } from '../udView/udview';

export const tagFields: Record<UDViewTagSelectionEnum, { name: string; shortName: string }> = {
    [UDViewTagSelectionEnum.None]: {
        name: 'None',
        shortName: 'None'
    },
    [UDViewTagSelectionEnum.Acid]: {
        name: 'Aircraft ID',
        shortName: 'Aircraft ID'
    },
    [UDViewTagSelectionEnum.Altitude]: {
        name: 'Altitude',
        shortName: 'Altitude'
    },
    [UDViewTagSelectionEnum.Speed]: {
        name: 'Speed',
        shortName: 'Speed'
    },
    [UDViewTagSelectionEnum.Origin]: {
        name: 'Origin',
        shortName: 'Origin'
    },
    [UDViewTagSelectionEnum.Destination]: {
        name: 'Destination',
        shortName: 'Dest'
    },
    [UDViewTagSelectionEnum.AircraftType]: {
        name: 'Aircraft type',
        shortName: 'ACType'
    },
    [UDViewTagSelectionEnum.DepTimeEtd]: {
        name: 'Dep time',
        shortName: 'Dep time'
    },
    [UDViewTagSelectionEnum.EtaFaa]: {
        name: 'ETA (FAA)',
        shortName: 'ETA'
    },
    [UDViewTagSelectionEnum.EtaFe]: {
        name: 'ETA (FE)',
        shortName: 'ETA(FE)'
    },
    [UDViewTagSelectionEnum.Scratchpad]: {
        name: 'Scratchpad',
        shortName: 'Scratchpad'
    },
    [UDViewTagSelectionEnum.TailNumber]: {
        name: 'Tail #*',
        shortName: 'Tail #'
    },
    [UDViewTagSelectionEnum.Latitude]: {
        name: 'Latitude',
        shortName: 'Latitude'
    },
    [UDViewTagSelectionEnum.Longitude]: {
        name: 'Longitude',
        shortName: 'Longitude'
    },
    [UDViewTagSelectionEnum.DistanceToDestination]: {
        name: 'Dist to dest',
        shortName: 'ToDest'
    },
    [UDViewTagSelectionEnum.EventText]: {
        name: 'Event text',
        shortName: 'Event'
    },
    [UDViewTagSelectionEnum.DestinationChange]: {
        name: 'Dest chg',
        shortName: 'Dest chg'
    },
    [UDViewTagSelectionEnum.PositionSource]: {
        name: 'Pos source',
        shortName: 'Pos src'
    },
    [UDViewTagSelectionEnum.LastDestination]: {
        name: 'Last dest',
        shortName: 'Last dest'
    },
    [UDViewTagSelectionEnum.CtdEdct]: {
        name: 'CTD/EDCT*',
        shortName: 'CTD/EDCT'
    },
    [UDViewTagSelectionEnum.ControlElement]: {
        name: 'Control elemnt*',
        shortName: 'Cont Elem'
    },
    [UDViewTagSelectionEnum.Track]: {
        name: 'Track',
        shortName: 'Track'
    },
    [UDViewTagSelectionEnum.DistanceOffRoute]: {
        name: 'Dist off route',
        shortName: 'Off Rt'
    },
    [UDViewTagSelectionEnum.FuelOnBoard]: {
        name: 'Fuel on board*',
        shortName: 'FOB'
    },
    [UDViewTagSelectionEnum.EtrFaa]: {
        name: 'ETR (FAA)',
        shortName: 'ETR'
    },
    [UDViewTagSelectionEnum.EtrFe]: {
        name: 'ETR (FE)',
        shortName: 'ETR(FE)'
    },
    [UDViewTagSelectionEnum.OriginGate]: {
        name: 'Origin gate*',
        shortName: 'Org gate'
    },
    [UDViewTagSelectionEnum.DestinationGate]: {
        name: 'Dest gate*',
        shortName: 'Dst gate'
    },
    [UDViewTagSelectionEnum.Priority]: {
        name: 'Priority*',
        shortName: 'Priority'
    },
    [UDViewTagSelectionEnum.NoseNumber]: {
        name: 'Nose #*',
        shortName: 'Nose #'
    },
    [UDViewTagSelectionEnum.AlternateDestination]: {
        name: 'Alternate dest*',
        shortName: 'Alt dest'
    },
    [UDViewTagSelectionEnum.CTA]: {
        name: 'CTA*',
        shortName: 'CTA'
    },
    [UDViewTagSelectionEnum.InitialDelayReason]: {
        name: 'Init delay rsn*',
        shortName: 'Init del rsn'
    },
    [UDViewTagSelectionEnum.LastDelayReason]: {
        name: 'Last delay rsn*',
        shortName: 'Last del rsn'
    },
    [UDViewTagSelectionEnum.Status]: {
        name: 'Status',
        shortName: 'Status'
    },
    [UDViewTagSelectionEnum.DepartureCenter]: {
        name: 'Dep center*',
        shortName: 'Dep ctr'
    },
    [UDViewTagSelectionEnum.ArrivalCenter]: {
        name: 'Arr center*',
        shortName: 'Arr ctr'
    },
    [UDViewTagSelectionEnum.OETD]: {
        name: 'OETD',
        shortName: 'OETD'
    },
    [UDViewTagSelectionEnum.OETA]: {
        name: 'OETA',
        shortName: 'OETA'
    },
    [UDViewTagSelectionEnum.OETE]: {
        name: 'OETE',
        shortName: 'OETE'
    },
    [UDViewTagSelectionEnum.ETE]: {
        name: 'ETE',
        shortName: 'ETE'
    },
    [UDViewTagSelectionEnum.ControlDepDel]: {
        name: "Ctrl'd dep del*",
        shortName: 'Ctl dep del'
    },
    [UDViewTagSelectionEnum.NonCtlDepDel]: {
        name: 'NonCtrl dep del',
        shortName: 'NCtl dep del'
    },
    [UDViewTagSelectionEnum.ControlArrivalDel]: {
        name: "Ctrl'd arr del*",
        shortName: 'Ctl arr del'
    },
    [UDViewTagSelectionEnum.NonCtlArrivalDel]: {
        name: 'NonCtrl arr del',
        shortName: 'NCtl arr del'
    },
    [UDViewTagSelectionEnum.EtedEvFromO]: {
        name: 'ETE dev fr schd',
        shortName: 'ETE dev'
    },
    [UDViewTagSelectionEnum.IrregularOperations]: {
        name: 'Irregular Op*',
        shortName: 'Irr Op'
    },
    [UDViewTagSelectionEnum.RouteText]: {
        name: 'Route text*',
        shortName: 'Route'
    },
    [UDViewTagSelectionEnum.FuelReserve]: {
        name: 'Reserve fuel*',
        shortName: 'Res fuel'
    },
    [UDViewTagSelectionEnum.PETD]: {
        name: 'PETD',
        shortName: 'PETD'
    },
    [UDViewTagSelectionEnum.PETA]: {
        name: 'PETA',
        shortName: 'PETA'
    },
    [UDViewTagSelectionEnum.PETE]: {
        name: 'PETE',
        shortName: 'PETE'
    },
    [UDViewTagSelectionEnum.CETE]: {
        name: 'CETE',
        shortName: 'CETE'
    },
    [UDViewTagSelectionEnum.Impacts]: {
        name: 'Impact(s)',
        shortName: 'Impact(s)'
    },
    [UDViewTagSelectionEnum.SectordeskId]: {
        name: 'Sector/Desk ID*',
        shortName: 'Sector/Desk ID'
    },
    [UDViewTagSelectionEnum.Out]: {
        name: 'OUT*',
        shortName: 'OUT'
    },
    [UDViewTagSelectionEnum.ElapsedSinceOut]: {
        name: 'Taxi time*',
        shortName: 'Taxi time'
    },
    [UDViewTagSelectionEnum.On]: {
        name: 'ON*',
        shortName: 'ON'
    },
    [UDViewTagSelectionEnum.In]: {
        name: 'IN*',
        shortName: 'IN'
    },
    [UDViewTagSelectionEnum.UserField2]: {
        name: 'User field 2*',
        shortName: 'User field 2'
    },
    [UDViewTagSelectionEnum.Holding]: {
        name: 'Holding',
        shortName: 'Holding'
    },
    [UDViewTagSelectionEnum.Diverting]: {
        name: 'Diverting',
        shortName: 'Diverting'
    },
    [UDViewTagSelectionEnum.ImpactAFM]: {
        name: 'Impacts (AFM)*',
        shortName: 'Impacts (AFM)'
    },
    [UDViewTagSelectionEnum.SincePositionUpdate]: {
        name: 'Since pos updt',
        shortName: 'Since pos updt'
    },
    [UDViewTagSelectionEnum.LastPositionTime]: {
        name: 'Last pos time',
        shortName: 'Last pos time'
    },
    [UDViewTagSelectionEnum.Off]: {
        name: 'OFF*',
        shortName: 'OFF'
    },
    [UDViewTagSelectionEnum.AlternateDestination2]: {
        name: 'Alternate dst2*',
        shortName: 'Alt dest 2'
    },
    [UDViewTagSelectionEnum.Divrecpri]: {
        name: 'Div rcvry pri*',
        shortName: 'Div rcvry pri'
    },
    [UDViewTagSelectionEnum.TOA]: {
        name: 'TOA*',
        shortName: 'TOA'
    },
    [UDViewTagSelectionEnum.Runway]: {
        name: 'Runway*',
        shortName: 'Runway'
    },
    [UDViewTagSelectionEnum.Pairedfixid]: {
        name: 'Paired fix*',
        shortName: 'Paired fix'
    },
    [UDViewTagSelectionEnum.NumSeats]: {
        name: 'Num seats*',
        shortName: 'Num seats'
    },
    [UDViewTagSelectionEnum.NumPassanger]: {
        name: 'Num passengers*',
        shortName: 'Numn pass'
    },
    [UDViewTagSelectionEnum.NumCrew]: {
        name: 'Num crew*',
        shortName: 'Num crew'
    },
    [UDViewTagSelectionEnum.CrewId]: {
        name: 'Crew ID*',
        shortName: 'Crew ID'
    },
    [UDViewTagSelectionEnum.MonitorStatus]: {
        name: 'Monitor Status',
        shortName: 'MonStat'
    },
    [UDViewTagSelectionEnum.Beacon]: {
        name: 'Beacon code*',
        shortName: 'Beacon'
    },
    [UDViewTagSelectionEnum.ModeS]: {
        name: 'Mode-S ID',
        shortName: 'Mode-S ID'
    },
    [UDViewTagSelectionEnum.ObjectClass]: {
        name: 'Object class',
        shortName: 'Object class'
    },
    [UDViewTagSelectionEnum.PlannedSpeed]: {
        name: 'Plan cruise spd',
        shortName: 'Pln cr spd'
    },
    [UDViewTagSelectionEnum.PlannedAltitude]: {
        name: 'Plan cruise alt',
        shortName: 'Pln cr alt'
    },
    [UDViewTagSelectionEnum.GoAround]: {
        name: 'Go Around',
        shortName: 'Go Around'
    },
    [UDViewTagSelectionEnum.DevAltPlan]: {
        name: 'Calc alt plan*',
        shortName: 'Calc alt plan'
    },
    [UDViewTagSelectionEnum.DevFobPlan]: {
        name: 'Calc fuel plan*',
        shortName: 'Calc fuel plan'
    },
    [UDViewTagSelectionEnum.DepartureDev]: {
        name: 'Dep deviation',
        shortName: 'Dep dev'
    },
    [UDViewTagSelectionEnum.ArrivalDev]: {
        name: 'Arr deviation',
        shortName: 'Arr dev'
    },
    [UDViewTagSelectionEnum.TaxiTime]: {
        name: 'Taxi time',
        shortName: 'Taxi time'
    },
    [UDViewTagSelectionEnum.Notes]: {
        name: 'Notes',
        shortName: 'Notes'
    },
    [UDViewTagSelectionEnum.AlternateDestinationOther]: {
        name: 'Alt dest other',
        shortName: 'Alt dest other'
    },
    [UDViewTagSelectionEnum.etopsAlts]: {
        name: 'ETOPs alts',
        shortName: 'ETOPs alts'
    },
    [UDViewTagSelectionEnum.FuelOnBoardTime]: {
        name: 'FOB Time',
        shortName: 'FOB Time'
    }
} as const;

export const tagFieldsOptions: DropdownItems<UDViewTagSelectionEnum> = Object.entries(tagFields)
    .map(([key, value]) => ({
        value: +key,
        text: value.name
    }))
    .toSorted((a, b) => a.text.localeCompare(b.text));

export default tagFields;
